<template>
  <b-card no-body class="cards card-box">
    <div class="infos-arquivos">
      <div class="row">
        <div class="form-group col-md-6">
          <input-date-time ref="dataObrigacao" :label="$t('GERAL.DATA_OBRIGACAO')" id="dataObrigacao" v-model="form.dataObrigacao" required />
        </div>
        <div class="form-group col-md-6">
          <input-date-time ref="dataPagamento" :label="$t('GERAL.DATA_PAGAMENTO')" id="dataPagamento" v-model="form.dataPagamento" required />
        </div>
        <div class="form-group col-md-12">
          <label for="textarea-small">{{$t('GERAL.DESCRICAO') + ' MME'}}</label>
          <b-form-textarea  type="textarea" :label="$t('GERAL.DESCRICAO')" id="descricao" v-model="form.descricao" placeholder="" value=""  rows="5" />
        </div>
      </div>
      <upload tituloArquivo="Arrastar Arquivo" @upload="(file, nomeArquivo)=> {
        form.arquivo = file
        form.nomeArquivo = nomeArquivo
        }" :arquivoDownloadNome="form.nomeArquivo"  selecioneArquivo="Selecionar Arquivo" type=".pdf" class="upload-boleto" />

      <b-button variant="success" v-if="permissao.c" type="submit" @click="salvar">
            <i class="fa-solid fa-cloud-arrow-up mr-2"></i>
            Enviar arquivo
      </b-button>
    </div>

    <div class="table-responsive">
      <b-table head-variant="dark" hover :items="items" :fields="campos">
        <template v-slot:cell(nomeArquivo)="item">
          <div @click="baixarBoleto(item)" class="flex">
            <i class="fas fa-file-pdf pdf-arquivos"></i>
            <span>{{ item.item.nomeArquivo }}</span>
          </div>
        </template>
        <template v-slot:cell(excluir)="item">
          <div class="flex">
            <b-button variant="flat-danger" v-if="permissao.d" @click="excluir(item)">
              <i class="fas fa-trash mr-2"></i>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
  </b-card>
</template>

<script>
import Confirmacao from "@/components/confirmacao/Confirmacao";
import MMEService from "@/common/services/mme/mme.service";
import InputDateTime from "@/components/inputs/InputDateTime";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import Upload from "@/components/upload/Upload";
import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Swal from "sweetalert2";
import { FormMixin } from "../../common/mixins/FormMixin";
export default {
  name: "mme",
  mixins : [FormMixin],
  components: {
    Upload,
    InputDateTime,
  },

  data() {
    return {
      form: {
        dataObrigacao : "",
        dataPagamento : "",
        descricao : "",
        arquivo : "",
        nomeArquivo : ""
      },
      campos: [
        {
          key: "nomeArquivo",
          label: this.$t("GERAL.NOME_ARQUIVO"),
        },
        {
          key: "descricao",
          label: this.$t("GERAL.DESCRICAO"),
        },
        {
          key: "dataObrigacao",
          label: this.$t("GERAL.DATA_OBRIGACAO"),
          formatter: (value) => {
            if (value) return helpers.formatarDataBr(value);
          },
        },
        {
          key: "dataPagamento",
          label: this.$t("GERAL.DATA_PAGAMENTO"),
          formatter: (value) => {
            if (value) return helpers.formatarDataBr(value);
          },
        },
        {
          key: "excluir",
          label: this.$t("GERAL.EXCLUIR"),
        },
      ],
      items: [
      ],
      totalRows: 5,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: this.$t("GERAL.PAGINACAO") }],
    };
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: "MME" }]);
    this.listar();
  },
  methods: {
    validarFormulario() {
      let arValidation = [];
      let refs = this.$refs;
      for (const key in refs) {
        if (Object.hasOwnProperty.call(refs, key)) {
          if(refs[key]){    
            arValidation.push(refs[key].valid());
          }
        }
      }

      return arValidation.filter((elem) => elem == false).length == 0;
    },
    listar() {
      this.$store.dispatch(START_LOADING);
      MMEService.listar()
        .then((result) => {
          
          let data = result.data.data.itens;

          this.items = data;

          this.totalRows = result.data.data.paginacao.totalDeElementos / this.perPage;
        })
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err.response.data.errors,
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
     baixarBoleto(item){
      var a = document.createElement("a"); //Create <a>
      a.href = item.item.arquivo //Image Base64 Goes here
      a.download = "arquivo.pdf"; //File name Here
      a.click(); //Downloaded file
    },
    salvar() {
      if (!this.validarFormulario()) return;

      this.$store.dispatch(START_LOADING);

      MMEService.salvar(this.form)
        .then(() => {
          Swal.fire({
            title: this.$t("GERAL.SUCCESSO"),
            text: this.$t("GERAL.MENSAGEM_CADASTRADO"),
            icon: "success",
            confirmButtonText: this.$t("GERAL.OK"),
          }).then(() => {
            this.form = {
              dataObrigacao : "",
              dataPagamento : "",
              descricao : "",
              arquivo : "",
              nomeArquivo : ""
            };
            this.listar();
          });
        })
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err.response.data.errors,
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    excluir(item) {
      Confirmacao.SimNao(
        this,
        null,
        this.$t("GERAL.CONFIRMAR_EXCLUIR").formatUnicorn({
          nome: item.nomeArquivo,
        })
      ).then(async (result) => {
        if (result.value) {
          this.$store.dispatch(START_LOADING);
          MMEService.excluir(item.item.id)
            .then(() => {
              Swal.fire({
                title: this.$t("GERAL.SUCCESSO"),
                text: this.$t("GERAL.MENSAGEM_EXCLUIDO"),
                icon: "success",
                confirmButtonText: this.$t("GERAL.OK"),
              }).then((result) => {
                if (result.isConfirmed) {
                  this.listar()
                }
              });
            })
            .catch((err) => {
              Swal.fire({
                title: this.$t("GERAL.ERRO"),
                text: err.response.data.errors,
                icon: "error",
              });
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },
  },
  computed : {
    permissao() {
      return this.$store.getters['app/retornaPermissao']('Mme');
    },
  }
};
</script>
